'use strict'; // https://github.com/mathiasbynens/String.prototype.at

var $export = require('./_export');

var $at = require('./_string-at')(true);

var $fails = require('./_fails');

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});
$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});